import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { StatuspageLogo } from '@atlaskit/logo';

import { AccountCreation } from '@/components/signup/account-creation/account-creation';
import { BlueWaveTemplate } from '@/components/signup/layouts/blue-wave-template';
import { usePremiumIntent, useStandardIntent } from '@/components/user-context/helpers/cohorts';
import { Picture } from '@/components/wpl/image/src/image';

import { NoCreditCardRequired } from '../components/no-credit-card-required';
import { SubHeading } from '../components/sub-heading';
import { SquareVisaCiscoPfizer } from '../jira/components/square-visa-cisco-pfizer';

export const LoggedOut = () => {
	const { formatMessage } = useIntl();
	const standard = useStandardIntent();
	const premium = usePremiumIntent();
	const productEditionText = premium
		? formatMessage({
				id: 'WacSignupHeader.cloudPremium',
				defaultMessage: 'Cloud Premium',
			})
		: standard
			? formatMessage({
					id: 'WacSignupHeader.cloudStandard',
					defaultMessage: 'Cloud Standard',
				})
			: formatMessage({
					id: 'WacSignupHeader.cloudFree',
					defaultMessage: 'Cloud Free',
				});
	const headingText =
		premium || standard
			? formatMessage({
					id: 'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingStandard',
					defaultMessage: 'Start now',
				})
			: formatMessage({
					id: 'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFree',
					defaultMessage: 'Get started',
				});
	const subHeadingText =
		premium || standard
			? formatMessage({
					id: 'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandard',
					defaultMessage: '7-day free trial for up to 10,000 users',
				})
			: formatMessage({
					id: 'WacSignupForm.freeAndNoCreditCardNeeded',
					defaultMessage: 'Free for up to 10 users. No credit card needed.',
				});
	return (
		<BlueWaveTemplate
			productEditionText={productEditionText}
			illustration={
				<Picture
					image={{
						src: 'https://atlassian.com/dam/jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674/Jira%20Hero.svg',
						alt: '',
					}}
				/>
			}
			socialProofLogos={<SquareVisaCiscoPfizer />}
			productLogos={[<StatuspageLogo key="statuspage" size="xlarge" appearance="inverse" />]}
			tagline={formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofText',
				defaultMessage: 'Trusted by over 65,000 teams worldwide',
			})}
			valueProps={formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeStatuspage',
				defaultMessage:
					'Free to set up. Launch it when you&rsquo;re ready.\nAccess to all features and capabilities\nZero obligation, no credit card required\nAdd up to 25 team members\nTechnical and sales support available',
			})
				.replace(/\n/g, '{newline}') // replace all newlines with a placeholder so we can split on it
				.replace(/&rsquo;/g, '’') // replace the &rsquo; with an actual apostrophe
				.split('{newline}')}
			showAtlassianLogo={true}
		>
			<h2 css={headingCss}>{headingText}</h2>
			<SubHeading>{subHeadingText}</SubHeading>
			<AccountCreation Login={<NoCreditCardRequired />} />
		</BlueWaveTemplate>
	);
};

const headingCss = css({
	fontSize: '2rem',
	fontWeight: 500,
	margin: 0,
	textAlign: 'center',
});
